import Button from "antd/lib/button"
import { Col, Row } from "antd/lib/grid"
import Select from "antd/lib/select"
import React from "react"
import { IEventOrderInfoModel, IEventStoreApplyModel } from "../../models/eventModel"
import Typography from "antd/lib/typography"
import Input from "antd/lib/input"
import { Divider } from "antd"
import EventServices from "../../services/event"
const { Title } = Typography;

const ChooseStore = (props: IProps) => {
  const { storeApplies, onChangeStore, eventId } = props
  const [storeCode, setStoreCode] = React.useState<string>()
  const [orderId, setOrderId] = React.useState<string>("")
  const [order, setOrder] = React.useState<IEventOrderInfoModel | null>(null)
  // const [orderIdError, setOrderIdError] = React.useState<string>()
  const [phoneNumber, setPhoneNumber] = React.useState<string>()
  // const [orderIsValid, setOrderIsValid] = React.useState<boolean>(false)
  // const []
  React.useEffect(() => {
    if (props?.storeApplies) {
      setStoreCode(props.storeApplies?.[0].code)
    }

}, [props?.storeApplies])

  const handleChangeStore = (value: string) => {
    setStoreCode(value)
  }

  const handleClickChooseStore = () => {
    if (!onChangeStore) {
      return;
    }
    onChangeStore(storeApplies?.find(x => x.code == storeCode), order)
  }

  const handleChangeOrderId = (value: string) => {
    setOrderId(value)
    setOrder(null)
  }

  const handleChangePhoneNumber = (value: string) => {
    setPhoneNumber(value)
  }

  const handleClickValidateOrder = async () => {
    if (!eventId) {
      return;
    }

    const response = await EventServices.validateOrder(eventId, {
      kde_order_id: orderId,
      customer_name: "",
      customer_phone: phoneNumber ? phoneNumber : "",
      store_code: ''
    })
    if (response) {
      setOrder({
        kdeOrderId: response.kde_order_id,
        customerName: response.customer_name,
        customerPhone: response.customer_phone,
        totalAmount: response.total_amount
      })
    } else {
      setOrder(null)
    }
  }



  const renderPhoneNumber = () => {
    if (!order?.customerPhone?.length) {
      return ""
    }
    let phone = order.customerPhone;
    let refix = '*'.repeat(phone.length - 3)
    return refix + phone.slice(-3);
  }

  const renderFooter = () => {
    if (!order) {
      return <></>
    }

    return <>
      <Row align={"middle"}>
        <Col span={24}>
          <Divider />
        </Col>
      </Row>
      <Row gutter={[16, 16]} align={"middle"}>
        <Col span={6}>
          <span>Mã đơn hàng:</span>
        </Col>
        <Col span={18}>
          <Title level={5} >{order?.kdeOrderId}</Title>
        </Col>
      </Row>
      <Row gutter={[16, 16]} align={"middle"}>
        <Col span={6}>
          <span>Khách hàng:</span>
        </Col>
        <Col span={18}>
          <Title level={5} >{order?.customerName}</Title>
        </Col>
      </Row>
      <Row gutter={[16, 16]} align={"middle"}>
        <Col span={6}>
          <span>Số điện thoại:</span>
        </Col>
        <Col span={18}>
          <Title level={5} >{renderPhoneNumber()}</Title>
        </Col>
      </Row>
      <Row justify={"end"} align={"middle"}>
        <Col span={8}>
          <Button type="primary"
            style={{ width: "100%" }}
            disabled={!order?.kdeOrderId?.length || !storeCode?.length || !phoneNumber?.length}
            onClick={handleClickChooseStore}>
            Xác nhận
          </Button>
        </Col>
      </Row>
    </>
  }

  if (!storeApplies?.length) {
    return <></>
  }

  return <div className="choose-store-wrapper">
    <Row justify={"center"} align={"middle"}>
      <Col md={16} sm={20} xs={22}>
        <Row gutter={[16, 16]} align={"middle"}>
          <Col span={6}>
            <span>Cửa hàng:</span>
          </Col>
          <Col span={18}>
            <Select style={{ width: "100%" }} value={storeCode} placeholder="Chọn cửa hàng" onChange={handleChangeStore}>
              {storeApplies?.map(s => <Select.Option value={s.code} key={s.code}>{s.name}</Select.Option>)}
            </Select>
          </Col>
        </Row>
        <Row gutter={[16, 16]} align={"middle"}>
          <Col span={6}>
            <span>Mã đơn hàng:</span>
          </Col>
          <Col span={18}>
            <Input placeholder="Nhập mã đơn hàng" onChange={(e) => handleChangeOrderId(e?.target?.value)} />
            {/* {orderIdError?.length && <Text type="danger">{orderIdError}</Text>} */}
          </Col>
        </Row>

        <Row gutter={[16, 16]} align={"middle"}>
          <Col span={6}>
            <span>Số điện thoại:</span>
          </Col>
          <Col span={18}>
            <Input.Password
              autoComplete="off"
              placeholder="Nhập số điện thoại"
              onChange={(e) => handleChangePhoneNumber(e?.target?.value)}
              visibilityToggle={(false)} />
            {/* {orderIdError?.length && <Text type="danger">{orderIdError}</Text>} */}
          </Col>
        </Row>
        <Row justify={"end"} align={"middle"}>
          <Col span={8}>
            <Button type="primary" style={{ width: "100%" }} disabled={!orderId?.length || !phoneNumber?.length} onClick={handleClickValidateOrder}>
              Kiểm tra đơn hàng
            </Button>
          </Col>
        </Row>
        {renderFooter()}
      </Col>
    </Row>

  </div>
}

export default ChooseStore

interface IProps {
  storeApplies: IEventStoreApplyModel[] | undefined,
  onChangeStore: (store: IEventStoreApplyModel | undefined, order: IEventOrderInfoModel | null) => void,
  eventId?: string
}